import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React, { Component } from 'react';
import { withStyles, createStyles } from '@material-ui/core/styles';
import cx from 'classnames';
import DataItem from './DataItem';
/**
 * @extends {React.Component<import('./types').DataTreeItemProps  & import('@material-ui/core').WithStyles<typeof styles, true>> }
 */

var DataTreeItem =
/*#__PURE__*/
function (_Component) {
  _inherits(DataTreeItem, _Component);

  function DataTreeItem() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DataTreeItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DataTreeItem)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleDragStart = function (e) {
      e.dataTransfer.setData('text/plain', _this.props.name);
      e.dataTransfer.setData('application/json', JSON.stringify({
        name: _this.props.name,
        xpath: _this.props.xpath,
        uuid: _this.props.uuid
      }));
    };

    return _this;
  }

  _createClass(DataTreeItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          xpath = _this$props.xpath,
          lightTheme = _this$props.lightTheme,
          onClick = _this$props.onClick,
          selected = _this$props.selected;

      var _this$props2 = this.props,
          classes = _this$props2.classes,
          dataProps = _objectWithoutProperties(_this$props2, ["classes"]);

      var isLeafNode = !children || children.length == 0;
      var rootClasses = cx(classes.item, selected && classes.selected, lightTheme ? classes.light : classes.dark, isLeafNode && classes.leafItem);
      return React.createElement("div", {
        className: rootClasses,
        draggable: true,
        onDragStart: this.handleDragStart,
        title: xpath,
        onClick: onClick
      }, React.createElement(DataItem, dataProps));
    }
  }]);

  return DataTreeItem;
}(Component);

var styles = function styles(theme) {
  return createStyles({
    item: {
      '&$light': {
        '&:hover': {
          backgroundColor: 'White'
        }
      },
      '&$dark': {
        '&:hover': {
          backgroundColor: theme.common.background.defaultContent
        }
      }
    },
    selected: {
      '&$light': {
        backgroundColor: 'White'
      },
      '&$dark': {
        backgroundColor: theme.common.background.defaultContent
      }
    },
    light: {},
    dark: {},
    leafItem: {
      marginLeft: 24
    }
  });
};

export default withStyles(styles, {
  withTheme: true,
  name: 'ECDataTreeItem'
})(DataTreeItem);